import { TokenManager } from "@forgerock/javascript-sdk";
import { createDeliveryClient } from "@kontent-ai/delivery-sdk";

export const initializeEmployerDeliveryClient = async () => {
  const accessToken = await TokenManager.getTokens();
  return createDeliveryClient({
    environmentId: "",
    proxy: {
      baseUrl: `${process.env.REACT_APP_BASE_URL}/KontentAi/v1`,
    },
    retryStrategy: { maxAttempts: 1 },
    globalHeaders: () => [
      {
        header: "Authorization",
        value: `Bearer ${accessToken?.accessToken}`,
      },
    ],
  });
};
